import NoteTemplate from './components/NoteTemplate.vue';

new window.Vue({
    el: '#app',

    data: {
        showReleaseNotes: false,
    },

    components: {
        NoteTemplate
    },

    methods: {
        showDynamicComponentModal: function(a) {
            var b = '';
            var _this = this;
            $.getJSON( "getReleaseNotes/" + a)
             .done(function(response) {
                    b = response.note;
                    a = response.version;
                    _this.$modal.show(NoteTemplate, {title: a, body: b}, {height: 'auto', scrollable: true});
                })
            .fail(function(response) {
                    console.log("ERROR: Getting Release Notes");
                    console.log(response)
                });
        },
    }
});
